export default __webpack_public_path__ + "static/media/Blog4_1.ee066166.jpg";